import React, { useEffect, useState } from 'react'
import { BaseCard } from '@verifier-user/verifier-headless-ui'
import { LoadingDialog } from '@verifier-user/verifier-cdr'
import { useApplicationContext } from '../../contexts/appContext'

export const EastVenturesSuccess = () => {
  const { getAccurassiResult } = useApplicationContext()
  const [error, setError] = useState(null)
  const [processing, setProcessing] = useState(false)

  const [gdxResult, setGdxResult] = useState({
    status: 'PENDING',
    hasSavings: false,
    date: ''
  })

  const [attempts, setAttempts] = useState(0)
  const maxAttempts = 5

  useEffect(() => {
    document.getElementsByTagName('body')[0].style.border = '1rem solid black'
    document.getElementById('header').style = 'padding-top: rem'
    document.getElementById('header-image').src = './images/GDX-logo-Large.png'
    document.getElementById('footer-image').src = './images/GDX-logo-Reversed-Large.png'
    document.getElementsByClassName('bGgcaH')[0].style.background = 'rgb(0 0 0)'
    document.getElementsByClassName('footer')[0].style.background = 'rgb(0 0 0)'
  }, [])

  useEffect(() => {
    setProcessing(true)
    let timeout = null
    if (gdxResult.status === 'ERROR' || attempts === maxAttempts) {
      onError(new Error('Failed to retrieve data from Green Data Exchange'))
    } else if (gdxResult.status !== 'SUCCESS') {
      timeout = setTimeout(() => {
        performRequest()
      }, 1500)
    } else {
      setProcessing(false)
      sessionStorage.clear()
      localStorage.clear()
    }

    return () => clearTimeout(timeout)
  }, [gdxResult.status, attempts])

  const performRequest = () => {
    setAttempts(attempts + 1)
    getAccurassiResult({
      onSuccess: (data) => {
        setGdxResult(data)
      },
      onError: (error) => {
        onError(error)
      }
    })
  }

  const onError = (error) => {
    sessionStorage.clear()
    localStorage.clear()
    setProcessing(false)
    setError(error)
  }

  const getErrorContent = () => {
    return (
      <div>
        <p data-testid={'modal-primary-content'}>
          Unfortunately there was an issue retrieving your result from <strong>Green Data Exchange</strong>.
        </p>
        <p data-testid={'modal-error-content'}>
          If the issue persists, please let us know by email at{' '}
          <a href='mailto:contact@greendataexchange.me' id='dataCollectProgress-errorContact-link'>
            contact@greendataexchange.me
          </a>
          , and this will be investigated.
        </p>
      </div>
    )
  }

  return (
    <>
      <LoadingDialog id={'fnf-eastventures-success'} isOpen={processing} />
      {error ? (
        getErrorContent()
      ) : gdxResult.status === 'SUCCESS' ? (
        <>
          {gdxResult.hasSavings ? (
            <h1 className={'text-4xl sm:text-5xl mb-8 leading-tight'} style={{ color: 'black' }}>
              Congratulations!
            </h1>
          ) : (
            <h1 className={'text-4xl sm:text-5xl mb-8 leading-tight'} style={{ color: 'black' }}>
              The results are in!
            </h1>
          )}
          <BaseCard className='mt-0 max-w-screen-md mb-6' data-testid='success-content'>
            <p data-testid='success-content-par-1'>
              {gdxResult.hasSavings ? (
                <span>
                  We're thrilled to let you know that we've identified savings for you based on your actual usage and
                  charges in {gdxResult.date}. Your energy adviser will be in touch to discuss these details and help
                  you switch. Stay tuned for more information!
                </span>
              ) : (
                <span>
                  We've completed a review of your {gdxResult.date} usage and charges, and we've uncovered some
                  opportunities, however no savings. Your energy adviser will be in touch to discuss these details with
                  you and guide you next steps and future options. Stay tuned for more information!
                </span>
              )}
            </p>
          </BaseCard>
        </>
      ) : (
        <span className='mt-0 max-w-screen-md mb-8'>
          <h1 className={'text-4xl leading-normal mb-8'}>Processing...</h1>
        </span>
      )}
    </>
  )
}
